import React, { ReactNode } from 'react';

interface HexagonProps {
  notify?: boolean;
  children: ReactNode;
  className?: string;
}

export function Hexagon(props: HexagonProps) {
  return (
    <svg
      className="text-chariot-stroke h-[1em] w-[0.8em] text-[40px]"
      width="0.8em"
      height="1em"
      viewBox="0 0 41 46"
      fill="none"
      style={{ zIndex: 1 }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="hexagonClip">
          <path d="M18.3125 3.03109C19.7048 2.22724 21.4202 2.22724 22.8125 3.03109L36.7311 11.067C38.1234 11.8708 38.9811 13.3564 38.9811 14.9641V31.0359C38.9811 32.6436 38.1234 34.1292 36.7311 34.933L22.8125 42.9689C21.4202 43.7728 19.7048 43.7728 18.3125 42.9689L4.39392 34.933C3.00161 34.1292 2.14392 32.6436 2.14392 31.0359V14.9641C2.14392 13.3564 3.00161 11.8708 4.39392 11.067L18.3125 3.03109Z" />
        </clipPath>
      </defs>
      <path
        id="Polygon 1"
        d="M18.3125 3.03109C19.7048 2.22724 21.4202 2.22724 22.8125 3.03109L36.7311 11.067C38.1234 11.8708 38.9811 13.3564 38.9811 14.9641V31.0359C38.9811 32.6436 38.1234 34.1292 36.7311 34.933L22.8125 42.9689C21.4202 43.7728 19.7048 43.7728 18.3125 42.9689L4.39392 34.933C3.00161 34.1292 2.14392 32.6436 2.14392 31.0359V14.9641C2.14392 13.3564 3.00161 11.8708 4.39392 11.067L18.3125 3.03109Z"
        fill="url(#pattern0_177_3156)"
        stroke="currentcolor"
        strokeWidth="5"
      />
      <foreignObject width="100%" height="100%" clipPath="url(#hexagonClip)">
        <div className="bg-chariot-background-secondary text-chariot-text-secondary flex size-full items-center justify-center">
          {props.children}
        </div>
      </foreignObject>
    </svg>
  );
}
